<template>
  <div
    v-if="options"
    class="merge-cart">
    <h3 class="merge-cart__header">
      {{ tStatic('superUserSignoutCartHeader') }}
    </h3>

    <p class="merge-cart__text">
      {{ tStatic('superUserSignoutCartText') }}
    </p>

    <div class="merge-cart__actions">
      <oie-base-button
        css-classes="button--ghost button--ghost-green"
        :text="tStatic('superUserSignoutCartYesTransferCart')"
        @click="transferCart()">
      </oie-base-button>

      <oie-base-button
        css-classes="button--ghost button--ghost-modal"
        :text="tStatic('superUserSignoutCartSkipTransfer')"
        @click="skipTransfer()">
      </oie-base-button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    options: {
      type: Object,
      default: null
    }
  },
  mounted() {
  },
  methods: {
    transferCart() {
      this.makeSelection(true)
    },
    skipTransfer() {
      this.makeSelection(false)
    },
    makeSelection(action) {
      window.location = `/mvcapi/se/sv/superuser/revertImpersonationAnonymous?transfercart=${action}&sourceMarket=${this.clientModel.currentMarket}`
    }
  }
}
</script>

<style lang="scss" scoped>
.merge-cart__header {
  margin-top: 0;
}

.merge-cart__text {
  margin-top: 0;
  margin-bottom: measure(full);
}

.merge-cart__actions > button {
  width: 100%;
  margin-bottom: measure(quarter);

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
